import {TipoFiltroEnum} from './Filtros.enum';
import {EventEmitter} from '@angular/core';

export class FiltroModel
{
  public TipoFiltro : TipoFiltroEnum = TipoFiltroEnum.Input; // tipo de filtro (input, select, fecha, etc)

  public Propiedad : string = ''; // nombre de la propiedad en el modelo de filtros que se envía al back end

  public Titulo : string = ''; // nombre de la etiqueta que se despliega en el control

  public Valor : any = null; // variable donde se guarda el valor del filtro

  public EtiquetasValor : any = null; // valor que se muestra en el select. (Multiselect, dropdwon, dropdownmulti)

  public DisplayValor : string = ''; // Nombre del atributo que se despliega en el multiselect o select. (Multiselect, dropdwon, dropdownmulti)

  public ValorName : string = ''; // nombre del atributo que se identificara como seleccionado, por ejemplo el id. (Multiselect, dropdwon, dropdownmulti)

  public Opciones : Array<any> = []; // opciones que se despliegan en el select.  (Multiselect, dropdwon, dropdownmulti)

  public Obligatorio : boolean = false; // indica si el filtro debe llevar un valor

  public MensajeError: string = ''; // es el mensaje de error que se muestra en caso de que el filtro sea obligatorio y no se haya seleccionado un valor.

  public Pattern : any = null; //expresión regular para validar dato (Input)

  public Mask : any = false; //mascara del dato (Input)

  public FechaInicio : any = null; //fecha inicio del filtro. (Fecha, RangoFecha)

  public FechaFin : any = null; // fecha fin del filtro. (RangoFecha)

  public disabled : boolean = false; // desactivar el filtro asignado
  public Hidden : boolean = false; // indica si el filtro se muestra en la vista

  public Buscar : boolean = true; // indica si permite la busqueda de los elementos. (Multiselect, dropdwon, dropdownmulti)

  public Suscripcion!: EventEmitter<any>; //suscripcion al valor

  constructor(init?:Partial<FiltroModel>)
  {
    Object.assign(this, init);
  }

}

